import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { apiGetPage } from '../../request/api'
import { useCustomData } from '../../pages/context/serviceCustomDataProvider';


interface ServiceHomePart2Props {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
    onOpenModal?: (data: any) => void;  // 改成 any 或更具体的 PlanData 类型
    onOpenNote?: (type: 'basic' | 'premium') => void;
}

interface eInteriorData {
    service: string;
    intbasicerior: string;
}

const ServiceHomePart2: React.FC<ServiceHomePart2Props> = ({ handleViewChange, data, onOpenModal, onOpenNote }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [foundationList, setFoundationList] = useState<eInteriorData[]>([]);
    const [seniorList, setSeniorList] = useState<eInteriorData[]>([]);
    const [extraSeniorServices, setExtraSeniorServices] = useState<eInteriorData[]>([]);
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';
    const [packageList, setPackageList] = useState<any[]>([]);
    const { getValue } = useCustomData();
    const [packageInfo, setPackageInfo] = useState<Record<string, string>>({});
    const getBasicName = () => {
        return packageInfo['89762F6A770A46FE83B7A39C5230E371'] || '基础版';
    };
    const getPremiumName = () => {
        return packageInfo['D7074AA0788643E68CA1B6F03F996EB3'] || '高级版';
    };
    const serviceHomeIncloud = getValue('serviceHomeIncloud');
    const iwant = getValue('iwant');
    const knowMore = getValue('knowMore');


    useEffect(() => {
        apiGetPage({
            tid: '0B5BEE67FE7B419C8C33CFD33A11CA5F',
            page: 1,
            size: 100,
            languagecode: languageCode,
            search: '',
        }).then(res => {
            const rows = res.data.data.rows || [];
            const foundationData = rows.filter((item: { belongToCommodity: string; }) =>
                item.belongToCommodity === '89762F6A770A46FE83B7A39C5230E371'); // 基础版

            const seniorData = rows.filter((item: { belongToCommodity: string; }) =>
                item.belongToCommodity === 'D7074AA0788643E68CA1B6F03F996EB3'); // 高级版

            const formatList = (data: any[]) => {
                const map = new Map<string, string>();
                data.forEach(item => {
                    if (!map.has(item.serviceScope)) {
                        map.set(item.serviceScope, item.littleRemark || '');
                    }
                });
                return Array.from(map).map(([service, intbasicerior]) => ({
                    service,
                    intbasicerior
                }));
            };

            const foundationListFormatted = formatList(foundationData);
            const seniorListFormatted = formatList(seniorData);

            const foundationServices = new Set(foundationListFormatted.map(item => item.service));
            const extraSeniorServices = seniorListFormatted.filter(item => !foundationServices.has(item.service));

            setFoundationList(foundationListFormatted);
            setExtraSeniorServices(extraSeniorServices);
        });


        apiGetPage({
            tid: '72D99CCB9A7E439184BF9EF7CABC49BA',
            page: 1,
            languagecode: languageCode,
            size: 100,
            search: 'isPackage:1'
        }).then(res => {
            const rows = res.data.data.rows || [];
            setPackageList(rows);
            // 仍然保留之前的 map，方便显示名称
            const map: Record<string, string> = {};
            rows.forEach((item: { id: string; commodityName: string }) => {
                map[item.id] = item.commodityName;
            });
            setPackageInfo(map);
        })
    }, []);

    const goBack = () => {
        handleViewChange('service-index');
    };

    return (
        <div className='service-home-part2'>
            {/* 基础版部分 */}
            <div className='part2-info left-service'>
                <div className='service-info-header'>
                    <p style={{ color: themeColor }}>{getBasicName()}</p>
                    <div>
                        <button
                            style={{ background: themeColor, boxShadow: `0 2px 4px 0` + themeColor }}
                            className='service-info-left-button'
                            onClick={() => {
                                // 找到基础版
                                const basicPlan = packageList.find(item => item.id === '89762F6A770A46FE83B7A39C5230E371');
                                if (basicPlan) {
                                    onOpenModal?.(basicPlan); // 传完整对象
                                }
                            }}
                        >
                            {iwant}
                        </button>
                        <button onClick={() => { handleViewChange('service-detail', '89762F6A770A46FE83B7A39C5230E371|B875F07C85DC4E7C9C73B07B4B10778D,3E13A0FC27854CDBACB51608D2203C0A') }} style={{ background: '#fff', border: `1px solid` + themeColor, color: themeColor }} className='service-info-right-button'>{knowMore}</button>
                    </div>
                </div>
                <div className='service-info-bottom'>
                    <div className='service-info-bottom-info'>
                        {foundationList.map((item, index) => (
                            <div className='foundationList-item' key={index}>
                                <div className='foundationList-item-info'>
                                    {item.service}
                                </div>
                                {item.intbasicerior && (
                                    <div className='foundationList-item-incloud' style={{ color: themeColor, border: `1px solid ` + themeColor }}>
                                        {item.intbasicerior}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* 高级版部分 - 只显示额外服务 */}
            <div className='part2-info right-service'>
                <div className='service-info-header'>
                    <p style={{ color: themeColor }}>{getPremiumName()}</p>
                    <div>
                        <button
                            onClick={() => {
                                const premiumPlan = packageList.find(item => item.id === 'D7074AA0788643E68CA1B6F03F996EB3');
                                if (premiumPlan) {
                                    onOpenModal?.(premiumPlan);
                                }
                            }}
                            style={{ background: themeColor, boxShadow: `0 2px 4px 0` + themeColor }}
                            className='service-info-left-button'
                        >
                            {iwant}
                        </button>
                        <button onClick={() => { handleViewChange('service-detail', 'D7074AA0788643E68CA1B6F03F996EB3|839B8C3A610E484EB76FDF329B378FAC,BAA4F165D89B43D399BAF8267FBDEFD5') }} style={{ background: '#fff', border: `1px solid` + themeColor, color: themeColor }} className='service-info-right-button'>{knowMore}</button>
                    </div>
                </div>
                <div className='service-info-bottom'>
                    <div className='service-info-bottom-incloud' style={{ color: themeColor }}>
                        {serviceHomeIncloud}
                    </div>
                    <div className='service-info-bottom-info'>
                        {extraSeniorServices.map((item, index) => (
                            <div className='foundationList-item' key={index}>
                                <div className='foundationList-item-info'>
                                    {item.service}
                                </div>
                                {item.intbasicerior && (
                                    <div className='foundationList-item-incloud' style={{ color: themeColor, border: `1px solid ` + themeColor }}>
                                        {item.intbasicerior}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ServiceHomePart2;